import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core';
import { FilterList as MFilter } from '@material-ui/icons/';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import CreateIcon from '@material-ui/icons/Create';
import Height from '@material-ui/icons/Height';
import HighlightOff from '@material-ui/icons/HighlightOff';
import Refresh from '@material-ui/icons/Refresh';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';
import { createPageApi, validDateObject } from '../../core';
import { AuditReviewSearchApi } from '../../core/audit-worhsheet-search-api';
import { RadioGroup } from '../../core/controls';
import { truncateSpan, withTooltip } from '../../core/format';
import { darkBlue, orange } from '../../core/theme';
import {
  VisitSearchApi,
  VisitSearchFieldCriteria,
  visitSearchApi,
} from '../../core/visit-search-api';

function Filter(props: VisitSearchFieldCriteria) {
  const { icon, editable, valueLabel, label, api } = props;
  const { deleteFilter, openFilter } = api.actions;
  
  const [valueState, setStateValue] = useState(null)

  const onDelete = () => {
    deleteFilter(props);
  };

  const onEdit = () => {
    openFilter(props);
  };


  useEffect(()=>{
    let temp = props?.field?.stringFilter;
    setStateValue(temp && (Array.isArray(temp) ? temp : temp.split(',')))
},[props])


  
  return (
    <Chip
      size="small"
      color="primary"
      label={
        <Grid
          container
          direction="row"
          spacing={1}
          justify="space-around"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid item style={{ paddingLeft: 11, paddingBottom: 5 }}>
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                color: 'white',
              }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item style={{ paddingBottom: 5 }}>
            <Typography
              color="textSecondary"
              variant="caption"
              style={{ whiteSpace: 'nowrap', color: 'white' }}
            >
              {/* {truncateSpan(
                values?.length>0 ? (values || '').toString() :  valueLabel(props),
                '90px',
                false
              )} */}
              {
                 truncateSpan(valueState ? (Array.isArray(valueState) ? valueState.join(', '): valueState) : valueLabel && valueLabel(props), '90px', false)
              }
            </Typography>
          </Grid>
          {editable ? (
            <Grid item>
              <IconButton
                onClick={onEdit}
                style={{ width: '8px', height: '8px' }}
                id={"edit-filter-" + label ? label?.toLowerCase()?.trim() : '' + "-btn"}
              >
                <CreateIcon fontSize="small" htmlColor="white" />
              </IconButton>
            </Grid>
          ) : null}
        </Grid>
      }
      onDelete={onDelete}
      icon={icon}
    />
  );
}

export function FilterEditor(props: VisitSearchFieldCriteria) {
  const { label, editor, form, api, field } = props;
  const { numFields } = form;

  
  const { closeFilter, addFilter, deleteFilter, search } = api.actions;
  const open = api.data((s) => s.openFilter);

  const onCancel = () => {
    closeFilter();
  };

  const onSave = async () => {
    await form.submit();

    const values: any = form.values.getState().value;
    if (
      values &&
      (values.control?.length == 0 ||
        values?.control == '' ||
        (form.numFields == 1 && !values.control))
    ) {
      
      deleteFilter(props);
      search();
      onCancel();
    }else if ((values.start && values.end) || field.startDate) {
      const start = new Date(values.start);
      const end = new Date(values.end);
      if (validDateObject(start) && validDateObject(end)) {
        addFilter(props);
        search();
        onCancel();
      }
    }else if (form.valid.getState().value) {
      addFilter(props);
      search();
      onCancel();
    }
  };

  return (
    <Dialog open={open}>
      {label && numFields > 1 && <DialogTitle>{label}</DialogTitle>}
      <DialogContent
        style={{ zIndex: 1501, width: 400, minHeight: 85, overflowY: 'hidden' }}
      >
        {editor({ ...props, ...{ api } })}
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
          {' '}
          Save{' '}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function FilterList(api: VisitSearchApi) {
  const filters = api.data((s) => s.filters);
  const selected = api.data((s) => s.selectedFilter);


  return (
    <Grid
      item 
      container
      direction="row"
      xs={5}
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%' }}
    >
      {(filters || []).map((v, i) => (
        <Grid item key={i}>
          {v?.field && <Filter {...v} api={api} />}
        </Grid>
      ))}
      {selected && <FilterEditor {...selected} api={api} />}
    </Grid>
  );
}

function Sort(props: VisitSearchFieldCriteria) {
  const { icon, label, field, api } = props;
  const { deleteSort } = api.actions;

  const [toggle, setToggle] = useState(field.sortOrder === 1);

  const onDelete = () => {
    deleteSort(props);
  };

  const onEdit = () => {
    setToggle(!toggle);
    field.sortOrder = !toggle ? -1 : 1;
    api.actions.updateSort(props);
  };

  return (
    <Chip
      size="small"
      color="secondary"
      style={{ backgroundColor: darkBlue }}
      label={
        <Grid
          container
          direction="row"
          spacing={1}
          justify="space-around"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid
            item
            style={{ paddingLeft: 11, paddingRight: 6, paddingBottom: 5 }}
          >
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                color: 'white',
              }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item>
            <IconButton
              onClick={onEdit}
              style={{ width: '8px', height: '8px' }}
              id={"edit-sort-" + label ? label?.toLowerCase()?.trim() : '' + "-btn"}
            >
              {field.sortOrder === -1 ? (
                <ArrowDownward fontSize="small" htmlColor="white" />
              ) : (
                <ArrowUpward fontSize="small" htmlColor="white" />
              )}
            </IconButton>
          </Grid>
        </Grid>
      }
      onDelete={onDelete}
      icon={icon}
    />
  );
}

function SortList(api: VisitSearchApi) {
  const sort = api.data((s) => s.sort);

  return (
    <Grid
      item
      container
      direction="row"
      xs={5}
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%' }}
    >
      {(sort || []).map((v, i) => (
        <Grid item key={i}>
          <Sort {...v} api={api} />
        </Grid>
      ))}
    </Grid>
  );
}

function FilterSort(props: VisitSearchFieldCriteria) {
  const { icon, label, api, field } = props;
  const { openFilter, addSort, hasFilter, hasSort } = api.actions;

  const onFilter = () => {
    openFilter(props);
  };
  const onSort = () => {
    addSort(props);
  };


  return (
    <Chip
      size="small"
      variant="outlined"
      label={
        <Grid
          container
          direction="row"
          spacing={0}
          justify="center"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid
            item
            style={{ paddingLeft: 6, paddingRight: 6, paddingBottom: 0 }}
          >
            <Typography
              style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item>
            <IconButton
              disabled={hasFilter(props)}
              onClick={onFilter}
              style={{ width: '8px', height: '8px' }}
            >
              {withTooltip(
                'Filter',
                <MFilter fontSize="small" style={{ paddingTop: 3 }} />
              )}
            </IconButton>
          </Grid>

          <Grid item>
            {field.sortable != false && <IconButton
              disabled={hasSort(props)}
              onClick={onSort}
              style={{ width: '8px', height: '8px' }}
            >
              {withTooltip(
                'Sort',
                <Height fontSize="inherit" style={{ paddingTop: 5 }} />
              )}
            </IconButton>}
          </Grid>
        </Grid>
      }
      icon={icon}
    />
  );
}

function FilterSortList(api: VisitSearchApi) {
  const pageApi = createPageApi();
  api = visitSearchApi(pageApi, true);
  const fields = api.data(s => s.fields);

  const { search, reset } = api.actions;

  
  // console.info(' Fileds ', api.data(s => s.sort));

  const onRefresh = () => {
    search();
  };
  const onReset = () => {
    reset();
    search();
  };

  return (
    <Grid
      item
      container
      direction="row"
      spacing={1}
      justify="flex-start"
      alignItems="center"
      style={{ width: '100%', height: '100%', paddingBottom: 6 }}
    >
      <Grid item style={{ paddingRight: 0 }}>
        <IconButton
          onClick={onRefresh}
          style={{ width: '12px', height: '12px' }}
          id="refresh_list"
        >
          {withTooltip(
            'Refresh List',
            <Refresh
              color="primary"
              fontSize="large"
              style={{ paddingTop: 4 }}
              id="refresh_list_icon"
            />
          )}
        </IconButton>
      </Grid>
      <Grid item style={{ paddingRight: 18 }}>
        <IconButton onClick={onReset} style={{ width: '12px', height: '12px' }} id="clear_fields_btn">
          {withTooltip(
            'Clear Fields',
            <HighlightOff
              color="primary"
              fontSize="large"
              style={{ paddingTop: 4 }}
              id="clear_fields_icon"
            />
          )}
        </IconButton>
      </Grid>
      {(fields || []).map((v, i) => (
        <Grid item key={i}>
          <FilterSort {...v} api={api} />
        </Grid>
      ))}
    </Grid>
  );
}

function MyAuditFilterSortList(api: AuditReviewSearchApi) {
  
  
  let checked= api.data.getState().isAudited;
  
  
  const fields = api.data(s => s.fields);

  const { search, reset, setAudited } = api.actions;
  const { filters } = api.data.getState()

  
 
  const onRefresh = () => {
    search();
  };
  const onReset = () => {
    reset();
    search();
  };

  const handleChange = () => {
    setAudited()
    search()
    
  }

  const checkIsDrilledDown = (): boolean => {
    let bool = false;
    filters.map(item => {
      if(typeof(item.form) === 'undefined'){
        bool = true;
        return;
      }
    })
    return bool;
  }

  return (
    <Grid
      item
      container
      direction="row"
      spacing={1}
      alignItems="center"
      style={{ width: '100%', height: '100%', paddingBottom: 6 }}
    >
      <Grid item
          direction="column"
          spacing={1}
          style={{flex: 0.4}}
          alignItems="center">
          
          <Grid
            item
            container
            direction="row"
            spacing={1}
            style={{justifyContent: 'center', minWidth: 165}}
            alignItems="center"
          >

            <Grid item style={{ paddingRight: 0 }}>
              <IconButton
                onClick={onRefresh}
                style={{ width: '12px', height: '12px' }}
                id="refresh_list"
              >
                {withTooltip(
                  'Refresh List',
                  <Refresh
                    color="primary"
                    fontSize="large"
                    style={{ paddingTop: 4 }}
                    id="refresh_list_icon"
                  />
                )}
              </IconButton>
            </Grid>
            <Grid>
              <IconButton onClick={onReset} style={{ width: '12px', height: '12px' }} id="clear_fields_btn">
                {withTooltip(
                  'Clear Fields',
                  <HighlightOff
                    color="primary"
                    fontSize="large"
                    style={{ paddingTop: 4 }}
                    id="clear_fields_icon"
                  />
                )}
              </IconButton>
            </Grid>
          </Grid>
              
      </Grid>

      <Grid item container
        direction="row"
        spacing={1}
        alignItems="center"
        style={{flex: 5}}>
        {(fields || []).map((v, i) => (
          
          <Grid item key={i}>
            <MyAuditFilterSort {...v as any} api={api}/>
          </Grid>
        ))}         

      </Grid>
      <Grid>
      {checkIsDrilledDown() ? 
        <Tooltip
        title={
          <span style={{ whiteSpace: 'pre-line', fontSize: 12, lineHeight: 1.7, display: 'block', verticalAlign: 'middle' }}>
            The worksheets are obtained by drilling down. In order to enable switching between the AUDITED and AUDITOR buttons, press <span style={{ width: '12px', height: '12px'  }}><HighlightOff
              color="primary"
              fontSize="small"
              style={{paddingTop: -3}}
            /></span> (clear all fields button).
          </span>
        }
        placement="top">
            <ToggleButtonGroup
              disabled={checkIsDrilledDown()}
              color={'error'}
              value={checked}
              style={{paddingTop: 5, color: darkBlue}}
              exclusive
              size='small'
              onChange={handleChange}
              aria-label="text alignment"
            >
              <ToggleButton value={true}>
              {withTooltip('Worksheets in which I am audited', <span>Audited</span>, 'top')}
              </ToggleButton>
              <ToggleButton value={false}>
              {withTooltip('Worksheets in which I am auditor', <span>Auditor</span>, 'top')}
              </ToggleButton>
          
          </ToggleButtonGroup>
        </Tooltip> : 
         <ToggleButtonGroup
            disabled={checkIsDrilledDown()}
            color={'error'}
            value={checked}
            style={{paddingTop: 5, color: darkBlue}}
            exclusive
            size='small'
            onChange={handleChange}
            aria-label="text alignment"
          >
            <ToggleButton value={true}>
            {withTooltip('Worksheets in which I am audited', <span>Audited</span>, 'top')}
            </ToggleButton>
            <ToggleButton value={false}>
            {withTooltip('Worksheets in which I am auditor', <span>Auditor</span>, 'top')}
            </ToggleButton>
        
         </ToggleButtonGroup>
         }
      </Grid>
      
    </Grid>
  );
}

function MyAuditFilterSort(props: VisitSearchFieldCriteria) {
  const { icon, label, api } = props;
  const { openFilter, addSort, hasFilter, hasSort, search } = api.actions;

  const onFilter = () => {
    openFilter(props as any);
  };
  const onSort = () => {
    addSort(props as any);
    search();
  };

  return (
    <Chip
      size="small"
      variant="outlined"
      label={
        <Grid
          container
          direction="row"
          spacing={0}
          justify="center"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid
            item
            style={{ paddingLeft: 6, paddingRight: 6, paddingBottom: 0 }}
          >
            <Typography
              style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item>
            <IconButton
              disabled={hasFilter(props as any)}
              onClick={onFilter}
              style={{ width: '8px', height: '8px' }}
            >
              {withTooltip(
                'Filter',
                <MFilter fontSize="small" style={{ paddingTop: 3 }} />
              )}
            </IconButton>
          </Grid>

          <Grid item>
            <IconButton
              disabled={hasSort(props as any)}
              onClick={onSort}
              style={{ width: '8px', height: '8px' }}
            >
              {withTooltip(
                'Sort',
                <Height fontSize="inherit" style={{ paddingTop: 5 }} />
              )}
            </IconButton>
          </Grid>
        </Grid>
      }
      icon={icon}
    />
  );
}


//TODO move predicate to individual filters
function Predicate(api: VisitSearchApi) {
  const { predicate } = api.forms.predicate.controls;
  return <RadioGroup {...predicate} />;
}

interface VisitSearchProps {
  api: VisitSearchApi;
}
export function AuditSearch(props: VisitSearchProps) {
  const { api } = props;

  return (
    <Grid
      item
      container
      direction="column"
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%', paddingBottom: 6, paddingTop: 0, minHeight: 76 }}
    >
       <FilterSortList {...api} /> 
      <Divider
        orientation="horizontal"
        style={{ width: '100%', height: '1px' }}
        flexItem
      />

      <Grid
        item
        container
        direction="row"
        spacing={1}
        justify="flex-start"
        alignItems="flex-start"
        style={{ width: '100%', paddingTop: 6 }}
      >
        <Grid item>
          <MFilter fontSize="small" htmlColor={orange} />
        </Grid>
        <FilterList {...api} />
        <Grid item>
          <Height fontSize="small" htmlColor={darkBlue} />
        </Grid>
        <SortList {...api} />
      </Grid>
    </Grid>
  );
}

export function MyAuditSearch(props: VisitSearchProps) {
  const { api } = props;

  return (
    <Grid
      item
      container
      direction="column"
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%', paddingBottom: 6, paddingTop: 0, minHeight: 76 }}
    >
       <MyAuditFilterSortList {...api as any} /> 
      <Divider
        orientation="horizontal"
        style={{ width: '100%', height: '1px' }}
        flexItem
      />

      <Grid
        item
        container
        direction="row"
        spacing={1}
        justify="flex-start"
        alignItems="flex-start"
        style={{ width: '100%', paddingTop: 6 }}
      >
        <Grid item>
          <MFilter fontSize="small" htmlColor={orange} />
        </Grid>
        <FilterList {...api} />
        <Grid item>
          <Height fontSize="small" htmlColor={darkBlue} />
        </Grid>
        <SortList {...api} />
      </Grid>
    </Grid>
  );
}

